"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPubSub = createPubSub;

var _react = require("react");

var _pubSub = require("./pub-sub");

function createPubSub() {
  const {
    subscribe,
    publish
  } = new _pubSub.PubSub();

  const useSubscribe = (event, callback) => {
    (0, _react.useEffect)(() => {
      const unsubscribe = subscribe(event, callback);
      return unsubscribe;
    }, []);
  };

  return {
    useSubscribe,
    publish
  };
}